import { lazy, ComponentType } from 'react';

const RETRY_KEY = 'lazy_chunk_retry';

/**
 * Wrapper around React.lazy that handles chunk load failures after deploys.
 * When Vite generates a new build, old chunk filenames are invalidated.
 * Users with stale tabs get "Failed to fetch dynamically imported module".
 * This wrapper detects that error, reloads once to fetch the new HTML with
 * updated chunk references, and only throws if the retry also fails.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  importFn: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    const hasRetried = sessionStorage.getItem(RETRY_KEY);

    try {
      const module = await importFn();
      sessionStorage.removeItem(RETRY_KEY);
      return module;
    } catch (error) {
      if (!hasRetried) {
        sessionStorage.setItem(RETRY_KEY, 'true');
        window.location.reload();
        return new Promise(() => {});
      }
      throw error;
    }
  });
}
